import { Autocomplete, Box, Button, Grid, MenuItem, TextField, Typography } from '@mui/material'
import { AppDispatch, RootState } from '../../store/store'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useGetAllCompaniesFilterQuery } from '../../store/api/backoffice/backofficeApi'
import { changeFilters } from '../../store/slices/backoffice/backofficeCompaniesSlice'

interface Company {
	companyDatabaseId: number
	companyName: string
}

function BackOfficeCompaniesFilters() {
	const dispatch = useDispatch<AppDispatch>()
	const backofficeCompanies = useSelector((state: RootState) => state.backofficeCompanies)
	const { data: companiesFilter, isLoading: isLoadingCompaniesFilter } = useGetAllCompaniesFilterQuery({})
	const [value, setValue] = useState<null | Company>(null)
	const [error, setError] = useState(false)
	const [inputValue, setInputValue] = useState('')

	const onlyNumb = /^[0-9]+$/

	const handleChangeDriver = (value: null | Company) => {
		if (value) {
			dispatch(
				changeFilters({
					...backofficeCompanies.filters,
					companyId: value.companyDatabaseId,
				}),
			)
		} else {
			dispatch(
				changeFilters({
					...backofficeCompanies.filters,
					companyId: undefined,
				}),
			)
		}
	}

	const handleFilterReset = () => {
		setValue(null)
		setInputValue('')
		dispatch(
			changeFilters({
				...backofficeCompanies.filters,
				companyId: undefined,
			}),
		)
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				padding: '0.8rem',
				paddingBlockStart: '0',
				bgcolor: 'grey.100',
			}}
		>
			<Grid
				container
				direction='row'
				spacing={2}
				xs={12}
			>
				<Grid
					item
					xs={4}
					sx={{ display: 'flex', flexDirection: 'row' }}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							marginBlockEnd: '1.5rem',
						}}
					>
						<Autocomplete
							value={value}
							onChange={(event, newValue: null | Company) => {
								handleChangeDriver(newValue)
								setValue(newValue)
							}}
							inputValue={inputValue}
							onInputChange={(event, newInputValue) => {
								setInputValue(newInputValue)
							}}
							options={companiesFilter?.data || []}
							filterOptions={options =>
								onlyNumb.test(inputValue)
									? options.filter(option => String(option.companyDatabaseId).includes(inputValue))
									: options.filter(option => option.companyName.toLowerCase().includes(inputValue.toLowerCase()))
							}
							getOptionLabel={option => option.companyName}
							sx={{
								display: 'flex',
								alignItems: 'center',
								flexDirection: 'row',
								width: '500px',
								bgcolor: 'white',
								minWidth: 120,
							}}
							renderOption={(props, option: Company) => {
								return (
									<MenuItem
										sx={{ display: 'flex', flexDirection: 'row' }}
										value={option.companyDatabaseId}
										{...props}
										key={option.companyDatabaseId}
									>
										<Typography sx={{ width: '85%' }}>{option.companyName}</Typography>
									</MenuItem>
								)
							}}
							renderInput={params => (
								<TextField
									{...params}
									label='Pesquisar Empresa'
									size='small'
									error={error}
									helperText={error ? 'Selecione uma empresa' : ''}
									onError={() => setError(true)}
								/>
							)}
							loading={isLoadingCompaniesFilter}
						/>
					</Box>
				</Grid>
			</Grid>
			<Grid
				container
				direction='row'
				spacing={2}
				xs={12}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						width: '100%',
						marginBlockStart: '0.5rem',
					}}
				>
					<Grid
						xs={3}
						display='flex'
						justifyContent='flex-end'
						alignItems='flex-end'
						sx={{ marginLeft: 'auto' }}
						item
					>
						<Button onClick={handleFilterReset}>LIMPAR FILTROS APLICADOS</Button>
					</Grid>
				</Box>
			</Grid>
		</Box>
	)
}

export default BackOfficeCompaniesFilters
